import React from 'react';
import { Alert, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Title } = Typography;

const TeachersNote = ({ customInstructions }) => {
    if (!customInstructions) {
        return null;
    }

    return (
        <Alert
            message={<Title level={4} style={{ margin: 0 }}>Teacher's Note</Title>}
            description={<div dangerouslySetInnerHTML={{ __html: customInstructions }} />}
            type="info"
            showIcon
            icon={<InfoCircleOutlined />}
        />
    );
};

export default TeachersNote;
